export const routes = {
  betaAccountEdit: {
    path: "/beta/account/:accountId/edit",
    name: "betaAccountEdit",
  },
  linkedBuyers: {
    path: "/account/:accountId/linked-buyers",
    name: "linked-buyers",
  },
};
